import React from "react";
import { Users, StickyNote, MapPin, AlertTriangle, Receipt } from "lucide-react";
import { STATUS, guestTags } from "../../lib/salaApi";

// Bookings of the service grouped by time (TheFork-style list). Tap a row to open its drawer.
export function BookingList({ rows, selectedId, onSelect }) {
  const groups = [];
  rows.forEach((b) => { const g = groups.find((x) => x.time === b.time); g ? g.items.push(b) : groups.push({ time: b.time, items: [b] }); });
  if (!rows.length) return <div className="rounded-3xl border border-dashed border-[#e8dcc8] bg-white/60 py-10 text-center text-sm italic text-[#7c5a4e]" data-testid="sala-list-empty">Nessuna prenotazione per questo servizio</div>;
  return (
    <div className="space-y-4" data-testid="sala-booking-list">
      {groups.map((g) => (
        <section key={g.time} className="rounded-3xl bg-white border border-[#e8dcc8] overflow-hidden">
          <header className="flex items-center gap-3 px-4 py-2.5 bg-[#faf3ee] border-b border-[#e8dcc8]">
            <span className="rounded-full bg-[#2b1410] text-white px-3 py-1 text-sm font-bold font-mono">{g.time}</span>
            <span className="text-xs text-[#7c5a4e] inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" /> {g.items.reduce((n, b) => n + (b.party_size || 0), 0)} coperti · {g.items.length} {g.items.length === 1 ? "tavolo" : "tavoli"}</span>
          </header>
          <ul className="divide-y divide-[#f1e6da]">
            {g.items.map((b) => <Row key={b.id} b={b} active={b.id === selectedId} onSelect={onSelect} />)}
          </ul>
        </section>
      ))}
    </div>
  );
}

function Row({ b, active, onSelect }) {
  const st = STATUS[b.status] || STATUS.confirmed;
  const tags = guestTags(b);
  return (
    <li>
      <button onClick={() => onSelect(b)} data-testid={`sala-row-${b.id}`} data-status={b.status}
        className={`w-full text-left px-4 py-3 flex items-start gap-3 transition-colors ${active ? "bg-[#fdf6e9]" : "hover:bg-[#faf3ee]"}`}>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-bold text-[#2b1410] text-base truncate">{b.name}</span>
            {b.type !== "table" && <span className="rounded-full bg-neutral-100 px-2 py-0.5 text-[10px] font-semibold text-neutral-600">{b.type === "private_event" ? "Evento privato" : "Appuntamento"}</span>}
          </div>
          {(tags.length > 0 || b.notes) && (
            <div className="mt-1 flex flex-wrap items-center gap-1.5">
              {tags.map((t) => <span key={t.k} data-channel={t.channel} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${t.cls}`}>{t.Icon && <t.Icon className="h-3 w-3" />}{t.label}</span>)}
              {b.notes && <span className="inline-flex items-center gap-1 text-xs text-[#7c5a4e] truncate max-w-[18rem]"><StickyNote className="h-3 w-3 shrink-0" /> {b.notes}</span>}
            </div>
          )}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className={`rounded-lg px-2.5 py-1 text-xs font-bold ${st.cls}`} data-testid={`sala-status-${b.id}`}>{st.label}</span>
          {b.pos?.stale_orders?.length > 0 && <span className="inline-flex items-center rounded-lg bg-amber-100 text-amber-900 px-1.5 py-1" title="Ordine in cassa da chiudere" data-testid={`sala-pos-stale-${b.id}`}><AlertTriangle className="h-3.5 w-3.5" /></span>}
          {b.pos?.order?.id && !b.pos?.stale_orders?.length && <span className="inline-flex items-center rounded-lg bg-sky-100 text-sky-900 px-1.5 py-1" title="Tavolo aperto in cassa" data-testid={`sala-pos-order-${b.id}`}><Receipt className="h-3.5 w-3.5" /></span>}
          <span className="text-sm font-semibold text-[#2b1410] w-8 text-right">{b.party_size}p</span>
          <span className={`inline-flex items-center gap-1 rounded-lg px-2 py-1 text-xs font-semibold min-w-[4.5rem] justify-center ${b.table ? "bg-[#4a1c17]/10 text-[#4a1c17]" : "bg-neutral-100 text-neutral-400"}`} data-testid={`sala-table-${b.id}`}>
            <MapPin className="h-3 w-3" /> {b.tables?.length > 1 ? `${b.table} +${b.tables.length - 1}` : b.table || "—"}
          </span>
        </div>
      </button>
    </li>
  );
}
